export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8717.f6f6571a.jpg";